import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2678f5af&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2678f5af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678f5af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2678f5af')) {
      api.createRecord('2678f5af', component.options)
    } else {
      api.reload('2678f5af', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2678f5af&scoped=true&", function () {
      api.rerender('2678f5af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobileProfilePage/index.vue"
export default component.exports